import { useTranslation } from "react-i18next";
import { Button } from "../../../components";
import { TransactionDetailProps } from "./TransactionDetailProps";
import { formatDate, formatTime } from "../../history.utils";
import useWindowDimensions, { CurrentScreen } from "../../../../../hooks/use-window-dimensions";
import styles from "../customer-transaction-history-detail.module.scss";
import { CopyIcon } from "../../../../../assets/icons";
import { formatCurrency, handleCopy } from "../../../../../utils";
import { getInstallmentPaymentTypeDisplay } from "../../../../../model/transaction";

export const InstallmentTransactionDetail = ({
  transaction,
}: TransactionDetailProps) => {
  const { t } = useTranslation();
  const currentScreen: CurrentScreen = useWindowDimensions();
  const installment = transaction.installmentDetails;

  return (
    <>

      <div className={styles.detailsCard}>
        

        {installment && (
        <>  

 <div className={styles.detailRow}>
            <span className={styles.detailLabel}>{t("history.web.paymentType")}</span>
            <span className={styles.detailValue}>
              {getInstallmentPaymentTypeDisplay(installment.paymentType)}
            </span>
          </div>
          </>
        )}

        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>{t("common.labels.amount")}</span>
          <span className={styles.detailValue}>{formatCurrency(transaction.amount?.amount ?? 0, {currency: transaction.amount?.currency})}</span>
        </div>

        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>{t("common.labels.date")}</span>
          <span className={styles.detailValue}>{formatDate(transaction.createdAt)}, {formatTime(transaction.createdAt).toLocaleLowerCase()}</span>
        </div>

      </div>


      <div className={styles.footer}>
        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>{t("history.web.transactionId")}</span>
          <div className={styles.copyContainer}>
            <span className={styles.detailValue}>
              {transaction.reference || t("history.web.notApplicable")}</span>
            {transaction.reference && <CopyIcon onClick={() => handleCopy(transaction.reference)
            } className={styles.copyBtn} />}
          </div>

        </div>

         <div className={styles.detailRow}>
          <span className={styles.detailLabel}>{t("history.requestIdLabel")}</span>
          <div className={styles.copyContainer}>
            <span className={styles.detailValue}>
              {installment?.repaymentMonthlyLoanProcessId || t("history.web.notApplicable")}</span>
            {installment?.repaymentMonthlyLoanProcessId && <CopyIcon onClick={() => handleCopy(installment?.repaymentMonthlyLoanProcessId)
            } className={styles.copyBtn} />}
          </div>

        </div>
      </div>    </>
  );
};
